import React from 'react';
import { formatLongDate, getCurrentQuarter } from '../../../utils/dateFormat';

const QuarterlyLeaveModal = ({ open, onClose, leaveType, quarters }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-3xl w-full shadow-lg relative">
        <h2 className="text-xl font-bold text-center mb-4">Quarterly View: {leaveType}</h2>
        <div className="mb-4">
          <table className="w-full border text-sm">
            <thead>
              <tr className="bg-slate-100">
                <th className="px-2 py-2 border whitespace-normal">Quarter</th>
                <th className="px-2 py-2 border whitespace-normal">Start</th>
                <th className="px-2 py-2 border whitespace-normal">End</th>
                <th className="px-2 py-2 border whitespace-normal">Allocated</th>
                <th className="px-2 py-2 border whitespace-normal">Taken</th>
                <th className="px-2 py-2 border whitespace-normal">Remaining</th>
                <th className="px-2 py-2 border whitespace-normal">Carry Forward</th>
              </tr>
            </thead>
            <tbody>
              {quarters.map(q => {
  const isCurrent = q.quarter === getCurrentQuarter();
  return (
    <tr key={q.quarter} className={isCurrent ? 'font-bold' : ''}>
      <td className="px-2 py-2 border text-center whitespace-normal">Q{q.quarter}</td>
      <td className="px-2 py-2 border whitespace-normal">{formatLongDate(q.start)}</td>
      <td className="px-2 py-2 border whitespace-normal">{formatLongDate(q.end)}</td>
      <td className="px-2 py-2 border text-center whitespace-normal">{q.allocated}</td>
      <td className="px-2 py-2 border text-center whitespace-normal">{q.taken}</td>
      <td className="px-2 py-2 border text-center whitespace-normal">{q.remaining}</td>
      <td className="px-2 py-2 border text-center whitespace-normal">{q.carry_forward}</td>
    </tr>
  );
})}
            </tbody>
          </table>
          <div className="text-xs text-yellow-700 bg-yellow-50 rounded px-2 py-1 mb-2">
              Note: Only the <span className="font-semibold">current quarter</span> values are accurate. All future quarter numbers will change based on your leaves used.
            </div>
        </div>
        <div className="flex justify-end">
          <button className="px-4 py-2 rounded bg-gray-200" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default QuarterlyLeaveModal;
